<script lang="ts" setup>
	defineProps<{
		label: string
		percentage: number
	}>()
</script>

<template>
	<div class="flex flex-wrap items-center gap-5">
		<div
			class="flex h-[156px] w-[156px] flex-none items-center justify-center rounded-full border border-purple-100 bg-purple-25 text-2xl font-semibold text-purple-500 sm:text-[48px]"
		>
			{{ percentage }}%
		</div>

		<h5 class="font-medium tracking-wide text-gray-700 sm:max-w-[200px] sm:text-base">
			{{ label }}
		</h5>
	</div>
</template>
